import L from 'leaflet';
import React, {Component} from 'react';
import {isObservableArray} from 'mobx';
import {observer, inject} from 'mobx-react';
import {Map, Marker, Polyline, Polygon, TileLayer} from 'react-leaflet';
import {Link} from 'react-router-dom';
import 'leaflet-touch-helper';
import Mousetrap from 'mousetrap';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faInfo} from '@fortawesome/free-solid-svg-icons'

import Button from "../../components/Button";

import BottomContainerDesktop from "./components/BottomContainerDesktop";
import BottomContainerMobile from "./components/BottomContainerMobile";
import IconDrop from "./components/DrawerContainer/components/IconDrop";
import PopupContainer from "./components/PopupContainer";
import PolylineDraw from "./components/PolylineDraw";
import PolygonDraw from "./components/PolygonDraw";

import './MapContainer.css';
import './leaflet.css';
import MapButtons from "./components/MapButtons";
import Legend from "./components/Legend";

@inject("appStore")
@observer
class MapContainer extends Component {


    componentDidMount = () => {
        Mousetrap.bind(['escape'], this.props.appStore.clearPending);
    };

    componentWillUnmount = () => {
        Mousetrap.unbind(['escape'], this.props.appStore.clearPending);
    };

    getTileLayerUrl = (layerName) => {
        const layerId = this.props.appStore.map.layerIds[layerName];
        if (!layerId) {
            console.error('Layer id must be specified in layerIds: ' + layerName);
        }
        if (layerId.custom) {
            return layerId.custom;
        }
        if (layerId.tiles) {
            return `https://api.mapbox.com/v4/${layerId.tiles}/{z}/{x}/{y}.jpg70?access_token=pk.eyJ1IjoidGFkaXJhbWFuIiwiYSI6IktzUnNGa28ifQ.PY_hnRMhS94SZmIR2AIgug`;
        } else {
            //CODE-REVIEW the URL had @2x (for Retina support?)
            return `https://api.mapbox.com/styles/v1/tadiraman/${layerId}/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoidGFkaXJhbWFuIiwiYSI6IktzUnNGa28ifQ.PY_hnRMhS94SZmIR2AIgug`;
        }
    };

    getOverlays = () => {
        return {layer: {attribution: "Sasaki", url: ''}, name: 'test', checked: true};
    };

    handleElementClick = (element) => {
        if (this.props.appStore.pendingState.element) return;
        if (isObservableArray(element.position)) {
            this.props.appStore.elementStore.makePendingElement(element, true);
            //CODE-REVIEW we should never set mobx state directly
            this.props.appStore.setSavePopup(true);
        } else {
            this.props.appStore.elementStore.makePendingElement(element, true);
            this.props.appStore.setSavePopup(true);
        }
    };

    onPolylineHover = (evt) => {
        // if (!this.props.appStore.pendingState){
        //     // polyline hover effect is currently being done with CSS :hover but this is incompatible with touchHelper due to touchHelper creating a seperate invisible SVG element
        //     // editing the polyline style in this function might be a better solution
        // }
    };

    onMapMount = (map) => {
        if (map) {
            this.props.appStore.configureElement(map.leafletElement);
        }
    };

    touchHelper = (element) => {
        if (element && this.props.appStore.map.element) {
            L.path.touchHelper(element.leafletElement, {extraWeight: 25}).addTo(this.props.appStore.map.element);
        }
    };

    onViewPortChange = (viewport) => {
        if (!viewport || !viewport.center) return;
        if (this.props.appStore.map) {
            this.props.appStore.setMapViewport({
                center: {
                    lat: viewport.center[0],
                    lng: viewport.center[1]
                },
                zoom: viewport.zoom
            });
        }
    };


    returnLeafletIcon = (image) => {
        return new L.Icon({
            iconUrl: `${process.env.PUBLIC_URL}/icons/${image}`,
            iconRetinaUrl: `${process.env.PUBLIC_URL}/icons/${image}`,
            iconAnchor: null,
            popupAnchor: null,
            shadowUrl: null,
            shadowSize: null,
            shadowAnchor: null,
            iconSize: new L.Point(45, 45),
            className: 'leaflet-div-icon'
        });
    };

    componentDidCatch(error, info) {
        console.log('MapContainer componentDidCatch: ' + error);
    }

    render() {

        return (
            <div className={(this.props.appStore.isMobile) ? "MapContainer mobile" : "MapContainer desktop"}>
                <Map
                    id={"leafletMapContainer"}
                    ref={this.onMapMount}
                    wheelPxPerZoomLevel={250}
                    onViewportChanged={this.onViewPortChange}
                    viewport={this.props.appStore.map.viewport}
                    zoomControl={false}
                    editable={true}
                    className={this.props.appStore.placingIconMode ? 'placingIconState' : 'viewMode'}
                    doubleClickZoom={true}
                    maxZoom={this.props.appStore.getMapZooms().maxZoom}
                    minZoom={this.props.appStore.getMapZooms().minZoom}
                >

                    <TileLayer
                        attribution="MapBox"
                        url={this.getTileLayerUrl(this.props.appStore.map.mode)}
                    />

                   {/* <TileLayer
                        attribution="Buildings"
                        url={'http://tiles.sasaki.com/emory-2018/v2.1/{z}/{x}/{y}.png'}
                    />*/}
                    {/*appStore.pendingElement('icon')*/}
                    {this.props.appStore.pendingState.element &&
                    this.props.appStore.pendingState.element.icon.type === 'icon' &&
                    <IconDrop/>
                    }

                    {/*appStore.nonPendingElements('icon')*/}
                    {this.props.appStore.elementStore.elements.map((element, index) =>
                        (this.props.appStore.elementStore.isNotPending(element) &&
                            element.icon.type === 'icon' &&
                            <Marker
                                key={element.uuid}
                                position={element.position}
                                icon={this.returnLeafletIcon(element.icon.image)}
                                draggable={false}
                                onClick={() => this.handleElementClick(element)}
                            >
                            </Marker>
                        ))}


                    {this.props.appStore.pendingState.element &&
                    this.props.appStore.pendingState.element.icon.type === 'polyline' &&
                    <PolylineDraw/>
                    }

                    {this.props.appStore.elementStore.elements.map((element, index) =>
                        (this.props.appStore.elementStore.isNotPending(element) &&
                            element.icon.type === 'polyline' &&
                            <Polyline
                                key={element.uuid}
                                positions={element.position.slice()}
                                color={element.icon.color}
                                className={"polyline"}
                                onClick={() => this.handleElementClick(element)}
                                onMouseover={(evt) => this.onPolylineHover(evt)}
                            >
                            </Polyline>
                        ))}

                    {/*{this.state.pendingElement &&*/}
                    {/*this.state.pendingElement.type === 'polyline' &&*/}
                    {/*this.state.pendingElement.routing === true &&*/}
                    {/*<RouteLineDraw map={this.leafletMap}*/}
                    {/*elementStore={this.props.elementStore}*/}
                    {/*pendingElement={this.state.pendingElement}*/}
                    {/*rModalHandler={this.editModalHandler}*/}
                    {/*toggleDrawerDisable={this.toggleDrawerDisable}*/}
                    {/*/>*/}
                    {/*}*/}
                    {/*{this.props.elementStore.elements.map((element, index) =>*/}
                    {/*(element !== this.state.pendingElement &&*/}
                    {/*element.type === 'polyline' &&*/}
                    {/*element.routing === true &&*/}
                    {/*<RouteLine*/}
                    {/*key={index}*/}
                    {/*map={this.leafletMap}*/}
                    {/*element={element}*/}
                    {/*clickHandler={this.handleElementClick}*/}
                    {/*// ref={this.touchHelper}*/}
                    {/*>*/}
                    {/*</RouteLine>*/}
                    {/*))}*/}


                    {this.props.appStore.pendingState.element &&
                    this.props.appStore.pendingState.element.icon.type === 'polygon' &&
                    <PolygonDraw/>
                    }

                    {this.props.appStore.elementStore.elements.map((element, index) =>
                        (this.props.appStore.elementStore.isNotPending(element) &&
                            element.icon.type === 'polygon' &&
                            <Polygon
                                key={index}
                                positions={element.position.slice()}
                                color={element.icon.color}
                                className={"polygon"}
                                onClick={() => this.handleElementClick(element)}
                            >
                            </Polygon>
                        ))}

                    {/*CODE-REVIEW KG: do we need to pass isMobile here as a prop if its on the appStore?*/}
                    {/*this.props.appStore.pendingState.element &&this.props.appStore.pendingState.savePopup &&*/}
                    {/*CODE-REVIEW KG: this.props.appStore.savePopup ??? this prop doesn't exist - why is it the class name?*/}
                    {this.props.appStore.pendingState.element && this.props.appStore.pendingState.savePopup &&
                    <div>
                        <PopupContainer isMobile={this.props.appStore.isMobile} appStore={this.props.appStore}/>
                    </div>
                    }

                </Map>
                <Legend/>
                {!this.props.appStore.isMobile &&
                <BottomContainerDesktop/>
                }

                {this.props.appStore.isMobile &&
                <BottomContainerMobile/>
                }

                {/*  {<MapButtons/>}*/}


                <Link
                    to={`/info`}>
                    <Button className="landingButton" aria-label="Info button">
                        <FontAwesomeIcon icon={faInfo}/>
                        {/*{intl.get("MapContainer.info_button")}*/}
                    </Button>
                </Link>


            </div>
        );
    }
}

export default MapContainer;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/index.js